/*
 * MMM · fiche produit, chantier 1 CRO (Mathilde Ma Muse, 09/2026).
 * Chargé seulement par les gabarits produit qui utilisent un bloc « mmm_ » (voir sections/main-product.liquid).
 *  1. Aperçu par ?view= : ajoute view= aux rechargements de section du thème.
 *  2. <mmm-etat> : stock en paliers + date de livraison calculée (jours ouvrés, jours fériés, fermeture de l'atelier).
 *  3. <mmm-cta-sticky> : barre collante + feuille de choix (bottom sheet).
 *  4. Galerie : recale l'image de la variante quand une vidéo a été insérée.
 *  5. « Écrivez à Mathilde » : ouverture du formulaire, variante à jour.
 *  6. Sélecteur : ligne d'explication de la pierre choisie.
 *  7. Visionneuse photo : le bouton retour du téléphone la ferme (au lieu de quitter la fiche).
 *  8. <mmm-composition> : zoom sur un composant du bijou, traits vers les textes (ordinateur).
 *  9. Grille d'avis : « Lire la suite » quand le texte dépasse, « Voir plus d'avis ».
 * Démo hors thème publié : ?mmm_etat=stock|bas|dernieres|pre|epuise|ferme force l'affichage d'un état.
 */
(() => {
  if (window.__mmmFiche) return;
  window.__mmmFiche = true;

  const ctx = document.querySelector('mmm-fiche-contexte');
  const FORM_ID = ctx ? ctx.dataset.formId : null;
  // Attention : sur un <form>, .id renvoie le champ nommé « id » (le thème s'en sert) ; on lit l'attribut.
  const idDe = (el) => (el && el.getAttribute ? el.getAttribute('id') : null);
  const estApercu = !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');

  /* 1. Aperçu d'un gabarit par ?view= : le thème recharge la section sans ce paramètre. */
  if (ctx && ctx.dataset.view) {
    const view = ctx.dataset.view;
    const handle = ctx.dataset.handle;
    const fetchOrigine = window.fetch;
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' && input.indexOf('/products/' + handle) !== -1 && input.indexOf('section_id=') !== -1 && input.indexOf('view=') === -1) {
          input += (input.indexOf('?') === -1 ? '?' : '&') + 'view=' + encodeURIComponent(view);
        }
      } catch (e) { /* on laisse passer la requête telle quelle */ }
      return fetchOrigine.call(this, input, init);
    };
  }

  /* Outils : dates à minuit (UTC) du jour de Paris */
  const jour = (d, n) => { const x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; };
  const cle = (d) => d.toISOString().slice(0, 10);
  function aujourdhuiParis() {
    const p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
  }
  function paques(y) { // algorithme de Meeus
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mois = Math.floor((h + l - 7 * m + 114) / 31), j = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, mois - 1, j));
  }
  const feries = {};
  function estFerie(d) {
    const y = d.getUTCFullYear();
    if (!feries[y]) {
      const p = paques(y);
      feries[y] = new Set(['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map((md) => y + '-' + md)
        .concat([jour(p, 1), jour(p, 39), jour(p, 50)].map(cle)));
    }
    return feries[y].has(cle(d));
  }
  const ouvre = (d) => { const w = d.getUTCDay(); return w !== 0 && w !== 6 && !estFerie(d); };
  function plusOuvres(d, n) { let x = d, k = 0; while (k < n) { x = jour(x, 1); if (ouvre(x)) k++; } return x; }
  function lireDate(t) { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((t || '').trim()); return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])) : null; }
  function formater(d) {
    return new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d).replace(/^(\S+) 1 /, '$1 1er ').replace(/(\d+(?:er)?) (\S+)$/, '$1\u00a0$2');
  }
  function prix(cents) {
    const format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    const v = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, cleF) => {
      if (cleF === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (cleF === 'amount_with_comma_separator') return v.replace('.', ',');
      if (cleF === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return v;
    });
  }

  /* Démo (thème non publié seulement) */
  const DEMO = (() => {
    if (!estApercu) return null;
    const e = new URLSearchParams(location.search).get('mmm_etat');
    return ['stock', 'bas', 'dernieres', 'pre', 'epuise', 'ferme'].indexOf(e) !== -1 ? e : null;
  })();

  function remplacerLibelle(bouton, ancien, nouveau) {
    if (!bouton) return;
    const w = document.createTreeWalker(bouton, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = w.nextNode())) { if (n.nodeValue.indexOf(ancien) !== -1) n.nodeValue = n.nodeValue.replace(ancien, nouveau); }
  }

  /* 2. Stock et livraison */
  class MmmEtat extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('[data-mmm-etats]').textContent); } catch (e) { return; }
      this.formId = this.dataset.formId;
      const v = this.data.variantes[this.dataset.variantId] || { etat: this.dataset.etat, qty: 0 };
      this.appliquer(v.etat, v.qty);
      this.onVariant = (e) => {
        if (!e.target || idDe(e.target) !== this.formId || !e.detail || !e.detail.variant) return;
        const w = this.data.variantes[e.detail.variant.id];
        if (w) this.appliquer(w.etat, w.qty);
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    disconnectedCallback() { document.removeEventListener('variant:change', this.onVariant); }

    fermeture(auj) {
      if (DEMO === 'ferme') return { du: auj, au: jour(auj, 10) };
      const du = lireDate(this.dataset.fermetureDu), au = lireDate(this.dataset.fermetureAu);
      if (!au) return null;
      if (auj > au) return null;
      if (du && auj < du) return null;
      return { du: du || auj, au };
    }

    appliquer(etat, qty) {
      if (DEMO) {
        etat = DEMO === 'ferme' ? 'stock' : DEMO;
        qty = { stock: 24, bas: 7, dernieres: 2, pre: 0, epuise: 0 }[etat];
      }
      const t = this.data.textes;
      this.dataset.etat = etat;
      const alerte = (t[etat] || '').replace('[qty]', qty);
      this.querySelector('[data-mmm-etat-texte]').textContent = alerte;
      const elAlerte = this.querySelector('[data-mmm-alerte]');
      if (elAlerte) elAlerte.hidden = !alerte;
      const elDispo = this.querySelector('[data-mmm-dispo]');
      if (elDispo) {
        const indispo = etat === 'pre' || etat === 'epuise';
        elDispo.textContent = indispo ? (t.indispo || 'Indisponible') : (t.dispo || 'Disponible');
        elDispo.classList.toggle('mmm-etat__dispo--non', indispo);
      }

      const auj = aujourdhuiParis();
      const jl = parseInt(this.dataset.joursLivraison, 10) || 3;
      const jf = parseInt(this.dataset.joursFabrication, 10) || 15;
      const f = this.fermeture(auj);
      const base = f ? f.au : auj; // on compte à partir du lendemain de la réouverture
      const elDate = this.querySelector('[data-mmm-etat-date]');
      const elFerm = this.querySelector('[data-mmm-etat-fermeture]');
      let date = null, phrase = '';
      if (etat === 'pre') { date = plusOuvres(jour(base, jf), jl); phrase = t.date_pre; }
      else if (etat !== 'epuise') { date = plusOuvres(base, jl); phrase = t.date; }
      const echap = (x) => String(x).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      elDate.innerHTML = date ? echap(phrase).replace('[date]', '<b>' + echap(formater(date)) + '</b>').replace('[jours]', jf) : '';
      elDate.hidden = !date;
      if (f && etat !== 'epuise') { elFerm.textContent = (t.fermeture || '').replace('[date]', formater(f.au)); elFerm.hidden = false; }
      else { elFerm.hidden = true; }

      this.etat = etat;
      document.dispatchEvent(new CustomEvent('mmm:etat', { detail: { formId: this.formId, etat, qty } }));

      if (DEMO) { // le libellé du bouton vient du serveur ; en démo on le force pour vérifier le rendu
        const form = document.forms[this.formId];
        const btn = form && form.querySelector('button[type="submit"]');
        if (etat === 'pre') remplacerLibelle(btn, 'Ajouter au panier', 'Précommander');
      }
    }
  }
  if (!customElements.get('mmm-etat')) customElements.define('mmm-etat', MmmEtat);

  /* 3. CTA sticky + feuille de choix */
  class MmmCtaSticky extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.form = document.forms[this.formId];
      this.barre = this.querySelector('[data-mmm-sticky]');
      this.feuille = this.querySelector('[data-mmm-feuille]');
      if (!this.form || !this.barre || !this.feuille) return;
      this.choix = false;
      this.libelle = this.dataset.libelle || 'Ajouter au panier';
      this.libellePre = this.dataset.libellePre || '';

      // Portail : hors des conteneurs du thème (un ancêtre transformé ou filtré casse position: fixed)
      this.hote = document.createElement('div');
      this.hote.className = 'mmm-portail';
      this.hote.append(this.barre, this.feuille);
      document.body.appendChild(this.hote);

      this.bouton = this.barre.querySelector('[data-mmm-sticky-btn]');
      this.detail = this.barre.querySelector('[data-mmm-detail]');
      this.panneau = this.feuille.querySelector('.mmm-feuille__panneau');

      // Visible dès que le bouton principal est passé au-dessus de l'écran. Calcul au défilement plutôt
      // qu'IntersectionObserver : un saut (lien d'ancre, défilement rapide) ne déclenche pas l'observateur.
      let attente = false;
      this.onScroll = () => {
        if (attente) return;
        attente = true;
        requestAnimationFrame(() => { attente = false; this.montrer(this.form.getBoundingClientRect().bottom < 0); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();

      this.onChange = (e) => {
        const t = e.target;
        if (e.isTrusted && t && t.matches && t.matches('input[data-option-position][form="' + this.formId + '"]')) this.choix = true;
      };
      document.addEventListener('change', this.onChange, true);
      this.onSubmit = () => { this.choix = true; };
      this.form.addEventListener('submit', this.onSubmit);

      this.onVariant = (e) => {
        if (!e.target || idDe(e.target) !== this.formId || !e.detail || !e.detail.variant) return;
        this.variant = e.detail.variant;
        this.majTextes();
      };
      document.addEventListener('variant:change', this.onVariant);
      this.onEtat = (e) => { if (e.detail.formId === this.formId) { this.etat = e.detail.etat; this.majTextes(); } };
      document.addEventListener('mmm:etat', this.onEtat);

      // 01/10 (Paul) : tant que la cliente n'a rien choisi, le bouton la ramène au sélecteur au lieu d'ajouter la variante affichée
      // par défaut (ou d'ouvrir la feuille de choix, qui reste en place mais n'est plus appelée).
      this.bouton.addEventListener('click', () => { if (this.choix) this.ajouter(); else this.versSelecteur(); });

      this.feuille.querySelectorAll('[data-mmm-cible]').forEach((b) => b.addEventListener('click', () => {
        const [pos, val] = b.dataset.mmmCible.split(':');
        const input = document.querySelector('input[form="' + this.formId + '"][data-option-position="' + pos + '"][value="' + val + '"]');
        if (input && !input.checked) input.click();
        this.choix = true;
        this.syncFeuille();
      }));
      this.feuille.querySelectorAll('[data-mmm-fermer]').forEach((b) => b.addEventListener('click', () => this.fermer()));
      this.feuille.querySelector('[data-mmm-valider]').addEventListener('click', () => { this.choix = true; this.fermer(); this.ajouter(); });
      this.onKey = (e) => { if (e.key === 'Escape' && !this.feuille.hidden) this.fermer(); };
      document.addEventListener('keydown', this.onKey);

      // Poignée : glisser vers le bas pour fermer
      const poignee = this.feuille.querySelector('[data-mmm-poignee]');
      let y0 = null;
      const debut = (e) => { y0 = (e.touches ? e.touches[0] : e).clientY; this.panneau.style.transition = 'none'; };
      const bouge = (e) => { if (y0 === null) return; const dy = Math.max(0, (e.touches ? e.touches[0] : e).clientY - y0); this.panneau.style.transform = 'translateY(' + dy + 'px)'; };
      const fin = (e) => {
        if (y0 === null) return;
        const dy = ((e.changedTouches ? e.changedTouches[0] : e).clientY) - y0;
        y0 = null; this.panneau.style.transition = ''; this.panneau.style.transform = '';
        if (dy > 60) this.fermer();
      };
      poignee.addEventListener('touchstart', debut, { passive: true });
      poignee.addEventListener('touchmove', bouge, { passive: true });
      poignee.addEventListener('touchend', fin);
      poignee.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') { debut(e); const up = (ev) => { fin(ev); window.removeEventListener('pointermove', bouge); window.removeEventListener('pointerup', up); }; window.addEventListener('pointermove', bouge); window.addEventListener('pointerup', up); } });

      // État de départ : <mmm-etat> a pu s'initialiser avant cette barre
      const etatEl = document.querySelector('mmm-etat[data-form-id="' + this.formId + '"]');
      if (etatEl) this.etat = etatEl.dataset.etat;
      try {
        const js = document.querySelector('variant-picker[form-id="' + this.formId + '"] script[data-variant]');
        if (js) this.variant = JSON.parse(js.textContent);
      } catch (e) { /* le prix reste celui rendu par le serveur */ }
      this.majTextes();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('change', this.onChange, true);
      document.removeEventListener('variant:change', this.onVariant);
      document.removeEventListener('mmm:etat', this.onEtat);
      document.removeEventListener('keydown', this.onKey);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.hote) this.hote.remove();
    }

    montrer(on) {
      if (this.visible === on) return;
      this.visible = on;
      this.barre.classList.toggle('est-visible', on);
      this.barre.setAttribute('aria-hidden', on ? 'false' : 'true');
      this.bouton.tabIndex = on ? 0 : -1;
      document.body.style.paddingBottom = on ? this.barre.offsetHeight + 'px' : '';
    }

    nomsChoisis() {
      const noms = [];
      this.feuille.querySelectorAll('.mmm-feuille__option').forEach((opt) => {
        opt.querySelectorAll('[data-mmm-cible]').forEach((b) => {
          const [pos, val] = b.dataset.mmmCible.split(':');
          const input = document.querySelector('input[form="' + this.formId + '"][data-option-position="' + pos + '"][value="' + val + '"]');
          if (input && input.checked) { const n = b.querySelector('.mmm-sel__nom'); if (n && n.firstChild) noms.push(n.firstChild.textContent.trim()); }
        });
      });
      return noms;
    }

    majTextes() {
      const pre = this.etat === 'pre' && this.libellePre;
      const libelle = pre ? this.libellePre : this.libelle;
      this.hote.querySelectorAll('[data-mmm-libelle]').forEach((el) => { el.textContent = libelle; });
      const v = this.variant;
      const montant = v ? prix(v.price) : null;
      const noms = this.nomsChoisis();
      if (this.detail) this.detail.textContent = noms.concat(montant ? [montant] : []).join(' · ') || this.detail.textContent;
      if (montant) this.hote.querySelectorAll('[data-mmm-prix]').forEach((el) => { el.textContent = montant; });
      this.syncFeuille();
    }

    syncFeuille() {
      this.feuille.querySelectorAll('[data-mmm-cible]').forEach((b) => {
        const [pos, val] = b.dataset.mmmCible.split(':');
        const input = document.querySelector('input[form="' + this.formId + '"][data-option-position="' + pos + '"][value="' + val + '"]');
        b.setAttribute('aria-pressed', input && input.checked ? 'true' : 'false');
      });
    }

    ouvrir() {
      this.syncFeuille();
      this.feuille.hidden = false;
      document.documentElement.classList.add('mmm-feuille-ouverte');
      requestAnimationFrame(() => { this.feuille.classList.add('est-ouverte'); this.panneau.focus({ preventScroll: true }); });
    }
    fermer() {
      this.feuille.classList.remove('est-ouverte');
      document.documentElement.classList.remove('mmm-feuille-ouverte');
      setTimeout(() => { this.feuille.hidden = true; }, 220);
      if (this.barre.classList.contains('est-visible')) this.bouton.focus({ preventScroll: true });
    }
    versSelecteur() {
      const sel = document.querySelector('variant-picker[form-id="' + this.formId + '"]') || document.querySelector('.product-info .mmm-sel');
      if (!sel) { this.ouvrir(); return; }
      const tete = document.querySelector('.shopify-section--header');
      const marge = (tete ? Math.max(0, tete.getBoundingClientRect().bottom) : 0) + 24;
      window.scrollTo({ top: Math.max(0, sel.getBoundingClientRect().top + window.scrollY - marge), behavior: 'smooth' });
      sel.classList.remove('mmm-signale'); void sel.offsetWidth; sel.classList.add('mmm-signale');
      setTimeout(() => sel.classList.remove('mmm-signale'), 1600);
    }
    ajouter() {
      const b = this.form.querySelector('button[type="submit"]');
      if (b && !b.disabled) b.click();
    }
  }
  if (!customElements.get('mmm-cta-sticky')) customElements.define('mmm-cta-sticky', MmmCtaSticky);

  /* 4. Galerie : après chaque changement de variante, on vérifie que la photo affichée est bien celle de la variante.
     Le thème recale par position (une vidéo insérée décale d'un cran) et, sur un vrai téléphone, un recalage lancé pendant que
     le carrousel défile encore peut être ignoré : on recontrôle juste après, puis 400 ms plus tard. */
  function recalerGalerie(mediaId) {
    const galerie = document.querySelector('product-gallery[form="' + FORM_ID + '"]');
    const car = galerie && galerie.querySelector('.product-gallery__carousel');
    const cells = car && car.cells;
    if (!cells || typeof car.select !== 'function') return;
    const i = cells.findIndex((c) => c.getAttribute('data-media-id') === String(mediaId));
    if (i < 0) return;
    const cr = car.getBoundingClientRect(), r = cells[i].getBoundingClientRect();
    const visible = Math.abs(r.left - cr.left) < 4 && Math.abs(r.top - cr.top) < 4;
    if (car.selectedCell !== cells[i] || !visible) car.select(i, { instant: true });
  }
  document.addEventListener('variant:change', (e) => {
    if (!FORM_ID || !e.target || idDe(e.target) !== FORM_ID || !e.detail || !e.detail.variant) return;
    const fm = e.detail.variant.featured_media;
    if (!fm) return;
    requestAnimationFrame(() => recalerGalerie(fm.id));
    setTimeout(() => recalerGalerie(fm.id), 400);
  });

  /* 5. « Écrivez à Mathilde » */
  function initQuestions() {
    document.querySelectorAll('.mmm-question').forEach((q) => {
      if (q.dataset.mmmPret) return;
      q.dataset.mmmPret = '1';
      const btn = q.querySelector('.mmm-question__ouvrir');
      const f = q.querySelector('form');
      if (!btn || !f) return;
      const regler = (o) => { f.classList.toggle('est-ouvert', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); };
      const retour = !!q.querySelector('[data-mmm-question-ok],[data-mmm-question-erreur]');
      regler(retour);
      if (retour) setTimeout(() => q.scrollIntoView({ block: 'center' }), 300);
      btn.addEventListener('click', () => {
        const o = !f.classList.contains('est-ouvert');
        regler(o);
        if (o) { const champ = f.querySelector('input[type="email"]'); if (champ) champ.focus(); }
      });
    });
  }
  document.addEventListener('variant:change', (e) => {
    if (!FORM_ID || !e.target || idDe(e.target) !== FORM_ID || !e.detail || !e.detail.variant) return;
    document.querySelectorAll('[data-mmm-question-variante]').forEach((h) => { h.value = e.detail.variant.title; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initQuestions); else initQuestions();

  /* 6. Sélecteur : ligne d'explication de la pierre choisie */
  function majSens() {
    document.querySelectorAll('[data-mmm-sens-choisi]').forEach((ligne) => {
      const sel = ligne.closest('.mmm-sel');
      const lab = sel && [...sel.querySelectorAll('label[data-mmm-sens]')].find((l) => { const i = document.getElementById(l.htmlFor); return i && i.checked; });
      if (lab) ligne.textContent = lab.dataset.mmmSens || '';
    });
  }
  document.addEventListener('change', (e) => { if (e.target && e.target.matches && e.target.matches('input[data-option-position]')) majSens(); });
  document.addEventListener('variant:change', majSens);

  /* 7. Visionneuse photo (PhotoSwipe du thème) : bouton retour du téléphone = fermer la visionneuse */
  let visionneuseEtat = false;
  const ouverte = () => document.querySelector('.pswp');
  new MutationObserver(() => {
    const v = ouverte();
    if (v && !visionneuseEtat) {
      visionneuseEtat = true;
      history.pushState({ mmmVisionneuse: true }, '');
      // la barre d'outils du thème est en bas et transformée : on sort la croix pour la poser en haut à droite
      let essais = 0;
      const poser = () => {
        const croix = v.querySelector('.pswp__top-bar > .circle-button--xl');
        if (croix) { croix.classList.add('mmm-pswp-croix'); v.appendChild(croix); }
        else if (essais++ < 30) requestAnimationFrame(poser);
      };
      poser();
    } else if (!v && visionneuseEtat) {
      visionneuseEtat = false;
      if (history.state && history.state.mmmVisionneuse) history.back();
    }
  }).observe(document.body, { childList: true });
  window.addEventListener('popstate', () => {
    const v = ouverte();
    if (v && visionneuseEtat) {
      visionneuseEtat = false;
      const croix = v.querySelector('.mmm-pswp-croix, .pswp__top-bar > .circle-button--xl');
      if (croix) croix.click(); else v.remove();
    }
  });

  /* 8. Composition du bijou : vue 3D (ou photo en secours), fenêtres sur mobile, traits sur ordinateur */
  const estMobile = () => window.matchMedia('(max-width: 999px)').matches;
  const webglOk = () => { try { const c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } };
  class MmmComposition extends HTMLElement {
    // Mode « fenêtre » (29/09, Paul) : boutons + et fenêtre de texte sur tous les écrans, sans textes latéraux ni traits.
    enFenetre() { return this.classList.contains('mmm-compo--fenetre') || estMobile(); }
    connectedCallback() {
      this.cadre = this.querySelector('[data-mmm-cadre]');
      this.zoom = this.querySelector('[data-mmm-zoom]');
      this.traits = this.querySelector('[data-mmm-traits]');
      this.ensemble = this.querySelector('[data-mmm-ensemble]');
      this.pop = this.querySelector('[data-mmm-pop]');
      this.items = [...this.querySelectorAll('[data-mmm-item]')];
      if (!this.cadre || !this.items.length) return;
      this.actif = null;
      this.items.forEach((it) => it.querySelector('.mmm-compo__declencheur').addEventListener('click', () => this.ouvrir(it.dataset.mmmItem)));
      this.querySelectorAll('.mmm-compo__zoom [data-mmm-point]').forEach((b) => b.addEventListener('click', () => this.ouvrir(b.dataset.mmmPoint)));
      if (this.ensemble) this.ensemble.addEventListener('click', () => this.fermer());
      if (this.pop) {
        this.pop.querySelector('[data-mmm-pop-fermer]').addEventListener('click', () => this.fermer());
        this.pop.querySelector('[data-mmm-pop-prec]').addEventListener('click', () => this.decaler(-1));
        this.pop.querySelector('[data-mmm-pop-suiv]').addEventListener('click', () => this.decaler(1));
      }
      this.dessiner = this.dessiner.bind(this);
      window.addEventListener('resize', this.dessiner, { passive: true });
      const img = this.zoom && this.zoom.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', this.dessiner, { once: true });
      this.dessiner();
      if (this.hasAttribute('data-mmm-3d') && this.dataset.module && webglOk()) {
        this.io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { this.io.disconnect(); this.charger3d(); } }, { rootMargin: '500px' });
        this.io.observe(this);
      } else if (this.hasAttribute('data-mmm-3d')) {
        const a = this.querySelector('[data-mmm-astuce]'); if (a) a.textContent = 'Touchez un numéro pour découvrir chaque détail';
      }
    }
    disconnectedCallback() { window.removeEventListener('resize', this.dessiner); if (this.io) this.io.disconnect(); if (this.scene) this.scene.detruire(); }

    // Attention : data-pendentif-1 ne se lit pas en dataset.pendentif1 (un tiret suivi d'un chiffre n'est pas converti).
    pierreChoisie() {
      const inputs = [...document.querySelectorAll('.mmm-sel__option--1 input[data-option-position="1"]')];
      const i = inputs.findIndex((x) => x.checked);
      const p1 = this.getAttribute('data-pendentif-1') || '', p2 = this.getAttribute('data-pendentif-2') || '';
      return (i === 1 ? p2 : p1) || p1 || p2;
    }

    async charger3d() {
      const hote = this.querySelector('[data-mmm-3d-hote]');
      if (!hote) return;
      try {
        const mod = await import(this.dataset.module);
        hote.hidden = false;
        this.boutons3d = {};
        this.items.forEach((it) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'mmm-compo__repere mmm-compo__repere--3d';
          if (this.classList.contains('mmm-compo--fenetre')) b.innerHTML = '<span class="mmm-compo__plus" aria-hidden="true"></span>'; else b.textContent = it.dataset.mmmItem;
          b.dataset.mmmPoint = it.dataset.mmmItem; b.setAttribute('aria-label', it.querySelector('.mmm-compo__nom').textContent);
          b.addEventListener('click', (e) => { e.stopPropagation(); this.ouvrir(it.dataset.mmmItem); });
          hote.appendChild(b);
          this.boutons3d[it.dataset.ancre] = b;
        });
        let dernier = 0;
        this.scene = await mod.monter(hote, {
          three: this.dataset.three,
          textures: { medaille: this.dataset.medaille, pendentif: this.pierreChoisie(), goutte: this.dataset.goutte },
          onReperes: (liste) => {
            // deux numéros à moins de 30 px se chevaucheraient : on les écarte le long de la droite qui les relie
            for (let i = 0; i < liste.length; i++) for (let j = i + 1; j < liste.length; j++) {
              const a = liste[i], b = liste[j], dx = b.x - a.x, dy = b.y - a.y, d = Math.hypot(dx, dy) || 0.01;
              if (d < 30 && a.visible && b.visible) { const k = (30 - d) / 2 / d; a.x -= dx * k; a.y -= dy * k; b.x += dx * k; b.y += dy * k; }
            }
            liste.forEach((r) => { const b = this.boutons3d[r.nom]; if (!b) return; b.style.left = r.x + 'px'; b.style.top = r.y + 'px'; b.classList.toggle('est-cache', !r.visible); });
            const t = performance.now(); if (t - dernier > 60) { dernier = t; this.dessiner(); }
          },
        });
        this.classList.add('est-3d');
        const astuce = this.querySelector('[data-mmm-astuce]');
        if (astuce && this.dataset.astuceOrdi && window.matchMedia('(hover: hover) and (pointer: fine)').matches) astuce.textContent = this.dataset.astuceOrdi;
        hote.addEventListener('pointerdown', () => this.classList.add('a-tourne'), { once: true }); // l'aide disparaît une fois le geste compris
        // Boutons « Pierre de lune / Labradorite » dans le cadre (29/09) : ils cliquent la vraie option du produit, pour que la pierre
        // vue en 3D soit celle du panier ; sans sélecteur sur la page, ils changent seulement la texture.
        const pierres = this.querySelector('[data-mmm-pierres]');
        const inputsPierre = () => [...document.querySelectorAll('.mmm-sel__option--1 input[data-option-position="1"]')];
        const majBoutons = () => {
          if (!pierres) return;
          const i = inputsPierre().findIndex((x) => x.checked);
          const actif = i >= 0 ? i : (this.textureCourante === this.getAttribute('data-pendentif-2') ? 1 : 0);
          pierres.querySelectorAll('[data-mmm-pierre]').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.mmmPierre === actif)));
        };
        if (pierres) {
          pierres.hidden = false;
          pierres.addEventListener('click', (e) => {
            const b = e.target.closest('[data-mmm-pierre]'); if (!b) return;
            const k = +b.dataset.mmmPierre, input = inputsPierre()[k];
            if (input) { if (!input.checked) input.click(); }
            else { const u = this.getAttribute(k === 1 ? 'data-pendentif-2' : 'data-pendentif-1'); if (u) { this.textureCourante = u; this.scene.definirPendentif(u); } }
            setTimeout(majBoutons, 60);
          });
        }
        this.onVariante = () => { const u = this.pierreChoisie(); if (u && u !== this.textureCourante) { this.textureCourante = u; this.scene.definirPendentif(u); } majBoutons(); };
        this.textureCourante = this.pierreChoisie();
        majBoutons();
        document.addEventListener('variant:change', this.onVariante);
        document.addEventListener('change', (e) => { if (e.target && e.target.matches && e.target.matches('input[data-option-position="1"]')) setTimeout(this.onVariante, 50); });
      } catch (e) {
        hote.hidden = true; this.classList.remove('est-3d');
        const a = this.querySelector('[data-mmm-astuce]'); if (a) a.textContent = 'Touchez un numéro pour découvrir chaque détail';
      }
    }

    ouvrir(n) {
      const it = this.items.find((x) => x.dataset.mmmItem === String(n));
      if (!it) return;
      if (this.actif === it) { this.fermer(); return; } // toucher le bouton actif (×) referme
      this.actif = it;
      this.items.forEach((x) => x.classList.toggle('est-actif', x === it));
      this.querySelectorAll('[data-mmm-point]').forEach((b) => b.classList.toggle('est-actif', b.dataset.mmmPoint === String(n)));
      this.classList.add('est-zoome');
      if (this.ensemble) this.ensemble.hidden = this.enFenetre();
      if (this.scene) { // le composant reste hors de la fenêtre : au-dessus sur mobile, à gauche sur ordinateur
        const ordiFenetre = this.classList.contains('mmm-compo--fenetre') && !estMobile();
        this.scene.focaliser(it.dataset.ancre, ordiFenetre ? 0 : (this.enFenetre() ? 0.24 : 0), ordiFenetre ? 0.2 : 0);
      }
      else if (!estMobile() && this.zoom) { // photo de secours : zoom sur ordinateur
        const z = parseFloat(it.dataset.zoom) || 2.2;
        this.zoom.style.transformOrigin = it.dataset.x + '% ' + it.dataset.y + '%';
        this.zoom.style.transform = 'scale(' + z + ')';
        this.zoom.querySelectorAll('[data-mmm-point]').forEach((b) => { b.style.transform = b.dataset.mmmPoint === String(n) ? 'scale(' + (1 / z) + ')' : ''; });
      }
      if (this.enFenetre() && this.pop) {
        this.pop.querySelector('[data-mmm-pop-num]').textContent = this.classList.contains('mmm-compo--fenetre') ? '' : String(n).padStart(2, '0');
        this.pop.querySelector('[data-mmm-pop-titre]').textContent = it.querySelector('.mmm-compo__nom').textContent;
        this.pop.querySelector('[data-mmm-pop-texte]').innerHTML = it.querySelector('.mmm-compo__texte').innerHTML;
        this.pop.querySelector('[data-mmm-pop-compte]').textContent = n + ' / ' + this.items.length;
        this.pop.hidden = false;
        requestAnimationFrame(() => this.pop.classList.add('est-ouvert'));
        const r = this.cadre.getBoundingClientRect();
        if (r.top < 0 || r.bottom > innerHeight) window.scrollBy({ top: r.top + r.height / 2 - innerHeight / 2, behavior: 'smooth' }); // vertical seulement
      }
    }
    decaler(sens) {
      const i = this.items.indexOf(this.actif);
      const j = (i + sens + this.items.length) % this.items.length;
      this.ouvrir(this.items[j].dataset.mmmItem);
    }
    fermer() {
      this.actif = null;
      this.items.forEach((x) => x.classList.remove('est-actif'));
      this.querySelectorAll('[data-mmm-point]').forEach((b) => { b.classList.remove('est-actif'); if (!b.classList.contains('mmm-compo__repere--3d')) b.style.transform = ''; });
      this.classList.remove('est-zoome');
      if (this.ensemble) this.ensemble.hidden = true;
      if (this.scene) this.scene.vueEnsemble();
      else if (this.zoom) this.zoom.style.transform = '';
      if (this.pop) { this.pop.classList.remove('est-ouvert'); setTimeout(() => { if (!this.actif) this.pop.hidden = true; }, 200); }
    }
    dessiner() {
      if (!this.traits) return;
      this.traits.innerHTML = '';
      if (this.enFenetre()) return;
      const base = this.getBoundingClientRect();
      this.traits.setAttribute('viewBox', '0 0 ' + base.width + ' ' + base.height);
      const ns = 'http://www.w3.org/2000/svg';
      const selPoint = this.scene ? '.mmm-compo__repere--3d' : '.mmm-compo__zoom [data-mmm-point]';
      this.items.forEach((it) => {
        const point = this.querySelector(selPoint + '[data-mmm-point="' + it.dataset.mmmItem + '"]');
        const nom = it.querySelector('.mmm-compo__nom');
        if (!point || !nom || point.classList.contains('est-cache')) return;
        const p = point.getBoundingClientRect(), t = nom.getBoundingClientRect();
        const gauche = it.dataset.cote === 'gauche';
        const x1 = (gauche ? t.right + 12 : t.left - 12) - base.left, y1 = t.top + t.height / 2 - base.top;
        const x2 = p.left + p.width / 2 - base.left, y2 = p.top + p.height / 2 - base.top;
        const coude = x2 + (gauche ? -1 : 1) * Math.min(60, Math.abs(x1 - x2) / 2);
        const l = document.createElementNS(ns, 'polyline');
        l.setAttribute('points', x1 + ',' + y1 + ' ' + coude + ',' + y1 + ' ' + x2 + ',' + y2);
        this.traits.appendChild(l);
        const c = document.createElementNS(ns, 'circle');
        c.setAttribute('cx', x1); c.setAttribute('cy', y1); c.setAttribute('r', 2.5);
        this.traits.appendChild(c);
      });
    }
  }
  if (!customElements.get('mmm-composition')) customElements.define('mmm-composition', MmmComposition);

  /* 9. Grille d'avis */
  function initAvis() {
    document.querySelectorAll('[data-mmm-avis-grille]').forEach((g) => {
      if (g.dataset.mmmPret) return;
      g.dataset.mmmPret = '1';
      const marquer = () => g.querySelectorAll('.mmm-avisg__carte:not([hidden])').forEach((c) => {
        const t = c.querySelector('[data-mmm-texte]'), b = c.querySelector('[data-mmm-suite]');
        if (t && b && !c.classList.contains('est-deplie')) b.hidden = t.scrollHeight <= t.clientHeight + 2;
      });
      g.addEventListener('click', (e) => {
        const b = e.target.closest('[data-mmm-suite]');
        if (!b) return;
        const c = b.closest('.mmm-avisg__carte');
        const o = !c.classList.contains('est-deplie');
        c.classList.toggle('est-deplie', o);
        b.textContent = o ? 'Réduire' : 'Lire la suite';
      });
      const plus = g.parentElement.querySelector('[data-mmm-avis-plus]');
      const pas = parseInt(g.dataset.parPage, 10) || 6;
      if (plus) plus.addEventListener('click', () => {
        const caches = [...g.querySelectorAll('.mmm-avisg__carte[hidden]')];
        caches.slice(0, pas).forEach((c) => { c.hidden = false; });
        if (caches.length <= pas) plus.hidden = true;
        requestAnimationFrame(marquer);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(marquer); else marquer();
      window.addEventListener('resize', marquer, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAvis); else initAvis();

  /* 10. Flèches des carrousels « Complétez avec » et avis (ordinateur) : une carte à la fois */
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-mmm-defiler]');
    if (!b) return;
    const zone = b.closest('[data-mmm-rail], .mmm-compl');
    const liste = zone && zone.querySelector('[data-mmm-slider]');
    if (!liste) return;
    const carte = liste.firstElementChild;
    const pas = carte ? carte.getBoundingClientRect().width + parseFloat(getComputedStyle(liste).columnGap || getComputedStyle(liste).gap || 0) : liste.clientWidth * 0.8;
    liste.scrollBy({ left: parseInt(b.dataset.mmmDefiler, 10) * pas, behavior: 'smooth' });
  });
  // flèches grisées aux extrémités
  const majFleches = (liste) => {
    const zone = liste.closest('[data-mmm-rail], .mmm-compl'); if (!zone) return;
    const max = liste.scrollWidth - liste.clientWidth - 2;
    zone.querySelectorAll('[data-mmm-defiler]').forEach((b) => { b.disabled = b.dataset.mmmDefiler === '-1' ? liste.scrollLeft <= 2 : liste.scrollLeft >= max; });
  };
  const initFleches = () => document.querySelectorAll('[data-mmm-slider]').forEach((l) => {
    if (l.dataset.mmmFleches) return; l.dataset.mmmFleches = '1';
    l.addEventListener('scroll', () => majFleches(l), { passive: true }); majFleches(l);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFleches); else initFleches();
  window.addEventListener('load', initFleches);

  /* 11. Deux colonnes sur ordinateur (28/09) : les rangées de gauche et de droite partent à la même hauteur.
     Rangée 1 : « Le mot de Mathilde » ↔ « Complétez avec » (en-têtes alignés, carte du mot étirée jusqu'au bas des photos des bijoux).
     Rangée 2 : « L'histoire du collier » ↔ « Elles le portent ». On n'ajoute que de l'espace (jamais de chevauchement) ;
     recalcul quand une colonne change de taille (images, Alma, polices). Rien sous 1000 px. */
  function alignerColonnes() {
    const gauche = document.querySelector('.product-content-below-gallery');
    const galerie = document.querySelector('product-gallery');
    const mot = gauche && gauche.querySelector('.mmm-mot-bloc');
    const compl = document.querySelector('.product-info .mmm-compl');
    const hist = gauche && gauche.querySelector('.mmm-desc');
    const avis = document.querySelector('.mmm-seulement-ordi .mmm-avis');
    const carte = mot && mot.querySelector('.mmm-mot');
    const piles = [gauche, compl, hist && hist.closest('.mmm-sous-galerie'), avis, carte];
    piles.forEach((e) => { if (e) { e.style.marginTop = ''; e.style.minHeight = ''; } });
    if (!window.matchMedia('(min-width: 1000px)').matches || !gauche || !galerie || !mot || !compl) return;
    const haut = (e) => e.getBoundingClientRect().top;
    const plus = (e, d) => { if (d > 0.5) e.style.marginTop = (parseFloat(getComputedStyle(e).marginTop) || 0) + d + 'px'; };
    // Rangée 1 : au plus haut, 40 px sous la galerie
    const cible = Math.max(haut(compl), galerie.getBoundingClientRect().bottom + 40);
    const dG = cible - haut(mot);
    gauche.style.marginTop = (parseFloat(getComputedStyle(gauche).marginTop) || 0) + dG + 'px';
    plus(compl, cible - haut(compl));
    const vignette = compl.querySelector('.mmm-compl__carte .mmm-compl__image');
    if (carte && vignette) {
      const h = vignette.getBoundingClientRect().bottom - haut(carte);
      if (h > carte.offsetHeight) carte.style.minHeight = h + 'px';
    }
    // Rangée 2
    if (hist && avis) {
      const bloc = hist.closest('.mmm-sous-galerie') || hist;
      const d = haut(avis) - haut(bloc);
      if (d > 0) plus(bloc, d); else plus(avis, -d);
    }
  }
  let alignAttente = false;
  const demanderAlignement = () => { if (alignAttente) return; alignAttente = true; requestAnimationFrame(() => { alignAttente = false; alignerColonnes(); }); };
  const initAlignement = () => {
    const cols = [document.querySelector('.product-info'), document.querySelector('.product-content-below-gallery')].filter(Boolean);
    if (cols.length < 2) return;
    if (window.ResizeObserver) { const ro = new ResizeObserver(demanderAlignement); cols.forEach((e) => ro.observe(e)); }
    window.addEventListener('resize', demanderAlignement, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(demanderAlignement);
    demanderAlignement();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAlignement); else initAlignement();
  window.addEventListener('load', demanderAlignement);
})();
